import React from 'react';
import { FormControlLabel, Switch, Box } from '@mui/material';

export default function InjectionDetectionSwitch({
  value,
  onChange,
  disabled = false,
}) {
  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            checked={Boolean(value)}
            onChange={(e) => onChange(e.target.checked)}
            name='injection_detection'
            disabled={disabled}
          />
        }
        label='Injection Detection'
      />
    </Box>
  );
}
